/**
 * Formats a time value (number or string) into a formatted time string
 *
 * @example
 * // With colon separator (default)
 * getFormattedTime(800) // "08:00"
 * getFormattedTime(1430) // "14:30"
 * getFormattedTime("0800") // "08:00"
 *
 * // With 'h' separator
 * getFormattedTime(800, 'h') // "8h"
 * getFormattedTime(830, 'h') // "8h30"
 * getFormattedTime(1430, 'h') // "14h30"
 */

export const getFormattedTime = (
	time?: number | string,
	separator: ':' | 'h' = ':',
) => {
	if (time === undefined || time === '') return ''

	const value = time.toString()
	const [hours, minutes] = value.includes(':')
		? value.split(':')
		: [value.padStart(4, '0').slice(0, 2), value.padStart(4, '0').slice(2, 4)]

	if (separator === 'h') {
		return `${Number(hours)}${separator}${minutes}`.replace('h00', 'h')
	}

	return `${hours}${separator}${minutes}`
}
